module.exports = __webpack_public_path__ + "72bb583f5840f61e0aa45e4267add7d1.woff";